import { createFeatureSelector } from '@ngrx/store';

export const onlineMenuPagesImagesState = createFeatureSelector<OLO.State, OLO.State.OnlineMenuPagesImages>('onlineMenuPagesImages');
